import { createTheme } from '@mui/material';

const theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#00549F',
    },
    background: {
      default: '#e0e0e0',
    },
  },
});

export default theme;
